var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdvancedMessagingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0937 4.51619C20.7402 4.20381 18.5153 4 16 4C13.4847 4 11.2598 4.20381 9.90633 4.51619C7.20767 5.08249 5.08249 7.20767 4.51619 9.90633C4.20381 11.2598 4 13.4847 4 16C4 18.5153 4.20381 20.7402 4.51619 22.0937C5.08249 24.7923 7.20767 26.9175 9.90633 27.4838C11.2598 27.7962 13.4847 28 16 28C18.5153 28 20.7402 27.7962 22.0937 27.4838C24.7923 26.9175 26.9175 24.7923 27.4838 22.0937C27.7962 20.7402 28 18.5153 28 16C28 13.4847 27.7962 11.2598 27.4838 9.90633C26.9175 7.20767 24.7923 5.08249 22.0937 4.51619Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9996 13.669C21.9996 12.1949 20.8045 11 19.3301 11H16.7578V20.0745H17.0902H19.3301C20.8045 20.0745 21.9996 18.8796 21.9996 17.4055V13.669Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.669C10 12.1949 11.1952 11 12.6695 11H16.9408C18.415 11 19.6103 12.1949 19.6103 13.669V17.4055C19.6103 18.8796 18.415 20.0745 16.9408 20.0745H12.3767C12.1342 20.0745 11.899 20.157 11.7097 20.3085L10.4337 21.329C10.3444 21.4005 10.2331 21.3893 10.1456 21.3446C10.0619 21.302 10 21.23 10 21.1206V13.669Z",
    fill: "url(#paint0_linear_3260_44321)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3260_44321",
    x1: 10.1867,
    y1: 15.8915,
    x2: 20.8284,
    y2: 15.8915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.272561,
    stopColor: "#FFC926"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEFBE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvancedMessagingIcon);
export default __webpack_public_path__ + "static/media/advanced_messaging_icon.ea949ca9d01db2d5e4fd29d8e5e2bd5a.svg";
export { ForwardRef as ReactComponent };